import { ForwardingTable } from '../components/ForwardingTable';

export function ForwardingPage() {
  return <ForwardingTable mode="admin" />;
}
